import Dialog from '@corvu/dialog'
import { Button, DialogShell } from '@forest/shared/solid'
import { m } from '~/paraglide/messages'

/**
 * The generic failure dialog of the claim/redeem error ladder — shown when a
 * write failed for a reason refetching cannot correct (network, 5xx).
 *
 * Composes the shared glass shell (`@forest/shared/solid`), which owns the
 * white/80 + blur(50) material and the 2px gradient inner stroke; only the
 * referral-specific z-index, overlay blur, spacing, and CTA glow live here.
 */
export function ConnectionIssueDialog(props: {
  open: boolean
  onClose: () => void
}) {
  return (
    <DialogShell
      role="alertdialog"
      open={props.open}
      onOpenChange={(open) => {
        if (!open) props.onClose()
      }}
      class="z-40 flex w-[300px] flex-col gap-6 p-6 ease-out data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0 data-[closed]:zoom-out-95 data-[open]:zoom-in-95"
      overlayClass="z-40 backdrop-blur-[12.5px] ease-out data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0"
    >
      <div class="flex flex-col gap-2 text-center">
        <Dialog.Label class="text-lg font-semibold leading-[26px] text-[#333]">
          {m.dialog_connection_issue_title()}
        </Dialog.Label>
        <Dialog.Description class="text-base leading-[22px] text-[#666]">
          {m.dialog_connection_issue_description()}
        </Dialog.Description>
      </div>
      <Button
        type="button"
        class="flex items-center justify-center text-base leading-5 shadow-[0_0_20px_-2px_rgba(198,255,205,0.15)] duration-150"
        onClick={() => props.onClose()}
      >
        {m.ok()}
      </Button>
    </DialogShell>
  )
}
